import {
  getAdaptiveActivityTaxonomyValue,
  parseAdaptiveTaxonomyId,
} from '@revelio/iso-utility';

import type { SelectionList } from '../../../../shared/selection-lists/types';
import { DEFAULT_ACTIVITY_TAXONOMY_ID } from '../contexts/defaultFilters';
import type { CustomActivityTaxonomySelection } from '../definitions/activityTaxonomy';
import type { TreeFilter } from '../types/filters';
import { extractRicsSelections } from '../utils/extractRicsSelections';

export { DEFAULT_ACTIVITY_TAXONOMY_ID };

// Extracts the relevant selections from the company filter and delegates the
// heavy-lifting to `getAdaptiveActivityTaxonomyValue`. The adaptive activity
// taxonomy is derived from this inside the reducer — see
// `deriveAdaptiveTaxonomies`.
export function getActivityTaxonomyValue(
  companyFilter: TreeFilter,
  ricsK400List: SelectionList<'rics_k400'>
): CustomActivityTaxonomySelection {
  const taxonomyId = getAdaptiveActivityTaxonomyValue({
    ricsK400List,
    ricsSelections: extractRicsSelections(companyFilter),
  });

  return {
    taxonomyId: parseAdaptiveTaxonomyId(taxonomyId, 'custom_activity'),
  };
}
